import { render, staticRenderFns } from "./BulkStatusActionDialog.vue?vue&type=template&id=32d4d548&"
import script from "./BulkStatusActionDialog.vue?vue&type=script&lang=ts&"
export * from "./BulkStatusActionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports